import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject, take } from 'rxjs';

import { AddressData } from './models/address-data';
import { EmployeePackage } from '@core/models';
import { EmployeeProfileService } from '@core/services';
import { BtnSize, BtnType } from '@shared/enums';
import { DropdownOptions } from '@shared/models/dropdown-options.interface';
import * as stateCodes from '@core/constants/us-state-codes';
import { Code } from '@core/models/codes.class';
import { NgForm, Validators } from '@angular/forms';
import { WizardStep } from 'app/features/wizard/wizard-step.interface';
import { forEachFormControl } from '@shared/utils/input-utils';

@Component({
  selector: 'sp-address',
  templateUrl: 'address.component.html',
  styleUrls: ['address.component.scss', '../forms.scss'],
})
export class AddressComponent implements OnInit, WizardStep {
  title = `What's your address?`;

  imageSrc: SafeResourceUrl;
  model: AddressData = {} as AddressData;
  btn = BtnType;
  size = BtnSize;
  stateOptions: DropdownOptions[] = [];
  employerReadyStates: string[];
  isStateSetupForTax$ = new BehaviorSubject<boolean>(true);

  private isDirtySubject$ = new BehaviorSubject(false);
  readonly isDirty$ = this.isDirtySubject$.asObservable();

  validators = {
    default: [Validators.required, Validators.maxLength(16)],
    apartment: [Validators.maxLength(16)],
    zip: [Validators.required, Validators.maxLength(10)],
  };

  @ViewChild(NgForm) form: NgForm;

  constructor(
    private employeeProfileService: EmployeeProfileService,
    protected _sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.employeeProfileService.employeeProfile$.pipe(take(1)).subscribe(personal => {
      this.employerReadyStates = personal.employerReadyStates;
      this.buildAddressInfoModel(personal);
    });

    this.setImage();
    this.buildStateCodesOptionsList();
  }

  setStateStatus(state: string) {
    this.isStateSetupForTax$.next(
      state?.length ?? 0 > 0 ? this.employerReadyStates?.includes(state) : true
    );
  }

  onModelUpdate() {
    this.isDirtySubject$.next(this.form.dirty);
  }

  onStateUpdate() {
    // separate callback for this check since it involves looping through array
    this.setStateStatus(this.model.state);
  }

  checkValidity = () => {
    if (this.form.valid) return true;

    forEachFormControl(this.form, ctrl => {
      if (ctrl.valid) return;
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
    return false;
  };

  onSubmit = () => {
    throw new Error('Method not implemented.');
  };

  private buildAddressInfoModel(pkg: EmployeePackage): void {
    if (!pkg || !pkg.personal) return;

    this.model.streetAddress = pkg.personal.address1;
    this.model.apartment = '';
    this.model.city = pkg.personal.city;
    this.model.state = pkg.personal.state;
    this.model.zip = pkg.personal.zip;

    this.setStateStatus(this.model.state);
  }

  private setImage(): void {
    this.imageSrc = this._sanitizer.bypassSecurityTrustResourceUrl(
      `assets/address/sp-onboarding-adress.svg`
    );
  }

  private buildStateCodesOptionsList(): void {
    stateCodes.USStateCodes.codes.forEach((code: Code) => {
      this.stateOptions.push({ label: code.value, value: code.value });
    });
  }
}
